/** Ranking and grouping of full-text search results. Stores return ids and snippets; this orders them. */
export type SearchHit = {
  kind: "note" | "task";
  id: string;
  title: string;
  snippet: string;
  /** Lower is better, as FTS5's `rank` is. */
  rank: number;
  updatedAt: string;
};

export function orderSearchHits(hits: readonly SearchHit[]): SearchHit[] {
  return [...hits].sort((a, b) => a.rank - b.rank || (a.updatedAt < b.updatedAt ? 1 : -1));
}

export function groupSearchHits(hits: readonly SearchHit[]): {
  notes: SearchHit[];
  tasks: SearchHit[];
} {
  const ordered = orderSearchHits(hits);
  return {
    notes: ordered.filter((h) => h.kind === "note"),
    tasks: ordered.filter((h) => h.kind === "task"),
  };
}

/** Simple subsequence fuzzy score for palette matching. Higher is better; -1 when no match. */
export function fuzzyScore(query: string, candidate: string): number {
  const q = query.toLowerCase();
  const c = candidate.toLowerCase();
  if (!q) return 0;
  if (c.startsWith(q)) return 1000 - c.length;
  const idx = c.indexOf(q);
  if (idx >= 0) return 500 - idx - (c.length - q.length) / 10;
  let qi = 0;
  let score = 0;
  let lastMatch = -2;
  for (let ci = 0; ci < c.length && qi < q.length; ci++) {
    if (c[ci] === q[qi]) {
      score += lastMatch === ci - 1 ? 3 : 1;
      if (ci === 0 || c[ci - 1] === " " || c[ci - 1] === "/" || c[ci - 1] === "-") score += 2;
      lastMatch = ci;
      qi++;
    }
  }
  return qi === q.length ? score : -1;
}
